import { AlignmentType, BorderStyle, HeadingLevel, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx";

function numberToWords(num) {
    const words = [
        "zero", "one", "two", "three", "four", "five",
        "six", "seven", "eight", "nine", "ten",
        "eleven", "twelve", "thirteen", "fourteen", "fifteen",
        "sixteen", "seventeen", "eighteen", "nineteen", "twenty",
        "twenty-one", "twenty-two", "twenty-three", "twenty-four", "twenty-five",
        "twenty-six", "twenty-seven", "twenty-eight", "twenty-nine", "thirty"
    ];

    if (num <= 30) return words[num];
    return num.toString();
}

export const observationSummary = new Paragraph({
    spacing: { before: 150, after: 100 },
    children: [new TextRun({
        text: "7.  Observation Summary",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
    heading: HeadingLevel.HEADING_2,
})

export function observationText1(certInApplicationName, VulCount) {
    const vulCountFormatted = `${numberToWords(VulCount)} (${VulCount})`;
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 200 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `During the security testing exercise, ISECURION security testing team (hereafter referred as the ‘testing team’) identified ${vulCountFormatted} vulnerabilities in the ${certInApplicationName} Source Code. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments. To enable risk-focused mitigation, these vulnerabilities are summarized in three different categories (High, Medium, Low).`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const scaleShown = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 100, after: 300 },

    children: [
        new TextRun({
            text: "The scale shown below has been used to rate the level of risk:",
            size: 22,
            color: "000000",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})


export const severityTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    borders: {
        top: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        bottom: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        left: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        right: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
    },

    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Rating",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "1b3661",
                    },
                    indent: {
                        left: 800
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "1b3661",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),
            ]
        }),



        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "H (High)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ff0000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Serious impact to the application security, generally unmitigated, large-scale issues, such as an attack that is currently exploitable from the Internet.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),

                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ff0000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "M (Medium)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffc000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Notable impact to the application security, or somewhat mitigated high risks (e.g., being available only to the user's Intranet)",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),
                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffc000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "L (Low)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffff00",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Potential impact to the application security, or heavily mitigated high risk (e.g., being in dead code or after an abort call).",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),
                            ]
                        }),
                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffff00",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),
            ]
        }),


    ]
})